module.exports = __webpack_public_path__ + "static/media/meeting-expand-arrow.675c153a.svg";